/**
 * Admin mode — a soft, on-device flag that gates admin-only tools (right now
 * just the in-place "rebuild & reload" control for the desktop-served webapp).
 *
 * WHY A SOFT GATE: the app is served only over Edd's private Tailscale (web) or
 * as the packaged APK today, so there is no real user/sign-in system to key off
 * yet. The existing `signedIn` flag in the shell store is itself a soft,
 * in-memory student gate, not real auth. So this is a persisted boolean, default
 * FALSE, meaning the admin controls never show for a normal student. It's
 * enabled by a discreet tap-count gesture on the version row (see UpdateSettings),
 * tucked away so students don't casually flip it. When real admin auth lands,
 * this should be replaced by keying off that instead.
 *
 * Persisted to localStorage so it survives an app reload (an Android kill), the
 * same way the boat settings do.
 */
import { create } from 'zustand';
import { loadJson, saveJson } from './persist';

const KEY = 'acp.admin.v1';

interface AdminState {
  /** Admin tools visible when true. Default false (persisted). */
  adminMode: boolean;
  setAdminMode: (on: boolean) => void;
  toggleAdminMode: () => void;
}

export const useAdminStore = create<AdminState>((set, get) => ({
  adminMode: loadJson<boolean>(KEY, false),
  setAdminMode: (on) => {
    saveJson(KEY, on);
    set({ adminMode: on });
  },
  toggleAdminMode: () => {
    const on = !get().adminMode;
    saveJson(KEY, on);
    set({ adminMode: on });
  },
}));
